/**
 * @description Deep-link for Add Alias → Company Settings modal → Merchant Alias.
 *
 * @dependencies none
 *
 * @notes
 * - Destination is /merchant/company#merchant-alias (existing modal), not a standalone page.
 * - Old /merchant/company/settings bookmarks should Navigate to COMPANY_SETTINGS_ALIAS_HREF.
 */

export const MERCHANT_ALIAS_HASH = '#merchant-alias';
export const MERCHANT_ALIAS_ANCHOR_ID = 'merchant-alias';
export const COMPANY_SETTINGS_ALIAS_HREF = `/merchant/company${MERCHANT_ALIAS_HASH}`;

/**
 * @param {string} [hash]
 * @returns {boolean}
 */
export function isMerchantAliasDeepLink(hash) {
  return hash === MERCHANT_ALIAS_HASH;
}

/**
 * Scroll the open Company Settings modal to Merchant Alias and focus the input.
 * @returns {boolean} true when the anchor was found
 */
export function focusMerchantAliasField() {
  const node = document.getElementById(MERCHANT_ALIAS_ANCHOR_ID);
  if (!node) return false;
  node.scrollIntoView({ behavior: 'smooth', block: 'center' });
  const input = document.getElementById('merchantAlias') || node.querySelector('input');
  input?.focus({ preventScroll: true });
  return true;
}
